// extracted by mini-css-extract-plugin
export default {"button":"fo-z","reviewSort":"go-z"};